import { Moment } from 'moment';

export function getMinutesFromDayStart(dateTime: Moment) {
  const startDay = dateTime.clone().startOf('day');
  return dateTime.diff(startDay, 'minutes');
}
